export class CompleteActivitySavingResultData {
    
}